import { ILegScanProps } from "../../../../../../../@types/components/legScanDetailsprops.types";
import "./ScanDetailsSections.css";

const ScanFiles = ({ legScan }: ILegScanProps) => {
	const files = [
		{ label: "Report PDF", url: legScan.report_link },
		{ label: "Left Scan (STL)", url: legScan.left_stl_url },
		{ label: "Right Scan (STL)", url: legScan.right_stl_url },
		{ label: "Left Scan Image", url: legScan.left_scan_image_url },
		{ label: "Right Scan Image", url: legScan.right_scan_image_url }
	].filter((file) => !!file.url);

	if (files.length === 0) return null;

	return (
		<div className="scan-files-list">
			{files.map((file) => (
				<a href={file.url} target="_blank" rel="noreferrer" key={file.label}>
					{file.label}
				</a>
			))}
		</div>
	);
};

export default ScanFiles;
